/**
 * Pagination Controls Component
 * Displays Previous / Page X / Next navigation
 */
import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const PaginationControls = ({ 
  currentPage, 
  hasMoreEvents, 
  loading, 
  onPreviousPage, 
  onNextPage 
}) => {
  return (
    <div className="flex justify-center items-center gap-4 mt-6">
      {/* Previous Button */}
      <button
        onClick={onPreviousPage}
        disabled={currentPage === 0 || loading}
        className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 flex items-center gap-1.5 ${
          currentPage === 0
            ? 'bg-gray-700/30 text-gray-500 cursor-not-allowed'
            : 'bg-gray-700/50 text-cyan-300 border border-cyan-500/30 hover:bg-cyan-500/20 hover:border-cyan-400/50'
        }`}
      >
        <ChevronLeft size={16} />
        Previous
      </button>
      
      {/* Page Indicator */}
      <span className="px-4 py-2 bg-gradient-to-r from-cyan-500/20 to-pink-500/20 border border-cyan-500/30 text-white rounded-lg text-sm font-medium">
        Page {currentPage + 1}
      </span>
      
      {/* Next Button */}
      <button
        onClick={onNextPage}
        disabled={!hasMoreEvents || loading}
        className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 flex items-center gap-1.5 ${
          !hasMoreEvents
            ? 'bg-gray-700/30 text-gray-500 cursor-not-allowed'
            : 'bg-gray-700/50 text-cyan-300 border border-cyan-500/30 hover:bg-cyan-500/20 hover:border-cyan-400/50'
        }`}
      >
        Next
        <ChevronRight size={16} />
      </button>
    </div>
  );
};

export default PaginationControls;
